import { Card } from 'antd';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '@shared/ui';

interface AuthLayoutProps {
  children: ReactNode;
}

/**
 * Обёртка для всех auth-страниц.
 * Центрирует карточку с формой по экрану, сверху — логотип.
 */
export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#F9FAFB',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px 16px',
      }}
    >
      <Link to="/" style={{ marginBottom: 32 }}>
        <Logo width={140} />
      </Link>

      <Card
        style={{
          width: '100%',
          maxWidth: 400,
          boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
        }}
        styles={{ body: { padding: '32px 28px' } }}
      >
        {children}
      </Card>

      <div style={{ marginTop: 24, color: '#9CA3AF', fontSize: 12 }}>
        © RiChat · Конструктор ИИ-ассистентов
      </div>
    </div>
  );
}
